import React from 'react';
import { FormattedMessage } from 'react-intl';

import { UISystemIcon } from '@futrli/ui-components';

import * as styles from './left-banner.scss';

export const LeftBanner = ({ invitedUser }: { invitedUser?: boolean }) => {
  return (
    <div className={styles.container}>
      <UISystemIcon iconName="white-by-sage-logo" width={325} height={146} />
      {invitedUser ? null : (
        <>
          <div className={styles.title} style={{ marginTop: 96 }}>
            <FormattedMessage id="register.try_14_days_free" defaultMessage="Try 14-days free" />
          </div>
          <div style={{ marginTop: 24 }}>
            <div className={styles.info}>
              <UISystemIcon iconName="credit-card" />
              <FormattedMessage id="register.no_credit_card_required" defaultMessage="No credit card required" />
            </div>
            <div className={styles.info}>
              <UISystemIcon iconName="dashboard" />
              <FormattedMessage
                id="register.get_started_3_minutes"
                defaultMessage="Get started in less than 3 minutes"
              />
            </div>
            <div className={styles.info}>
              <UISystemIcon iconName="chart-bar" />
              <FormattedMessage id="register.explore_futrli" defaultMessage="Explore Futrli’s full capabilities" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
